<tt-page class="col-xs-12 col-md-4 sp-0" *ngIf="!!itemsListWorkShifts">
    <tt-list [ttData]="itemsListWorkShifts" ttBackStyle [ttGoto]="false" (ttClick)="goBackToPrevious($event)"></tt-list>

    <tt-card>
        <tt-button ttText="interrupt" (ttClick)="cancelToPrevious()" ttIcon="fa fa-chevron-left" ttType="danger" ttIconAlign="left"></tt-button>
    </tt-card>
</tt-page>
